import { render, staticRenderFns } from "./EventoCreateView.vue?vue&type=template&id=94bcef1c&scoped=true&"
import script from "./EventoCreateView.vue?vue&type=script&lang=js&"
export * from "./EventoCreateView.vue?vue&type=script&lang=js&"
import style0 from "./EventoCreateView.vue?vue&type=style&index=0&id=94bcef1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bcef1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VAutocomplete,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VFlex,
  VLayout,
  VSpacer,
  VTextField,
  VTextarea,
  VToolbar,
  VToolbarTitle,
})
